export default __webpack_public_path__ + "static/media/mcrdIcon.0531027a.png";